import type { ReactNode } from 'react';
import { media, useMediaQuery } from '@savvy-kit/hooks/use-media-query';
import { cn } from '@savvy-kit/lib/utils';
import { isNil } from 'es-toolkit';
import { GUIDED_FLOW_MAX_WIDTH } from 'src/constants/guided-flow';

import { loggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';
import { XSavvyFooter } from '@savvy/deprecated-shared/x-components/x-savvy-footer';
import { XSavvyLogo } from '@savvy/deprecated-shared/x-components/x-savvy-logo';

// Used for intros and outros to a guided flow
export default function GuidedFlowDoormat({
  maxWidth = GUIDED_FLOW_MAX_WIDTH,
  maxHeight,
  children,
}: {
  readonly maxWidth?: number;
  readonly maxHeight?: number;
  readonly children: ReactNode;
}) {
  const lgDevice = useMediaQuery(media.up('lg'));
  const advisorId = loggedInAsAdvisorID();
  const isAdvisorLoggedInAsClient = !isNil(advisorId) && advisorId !== '';

  return (
    <div className="px-6 box-border">
      {/* TODO: Remove absolute positioning, and make everything regular flex display */}
      <div
        className={cn(
          'flex flex-col items-center justify-center absolute left-0 w-full',
          // Adjust for banner
          lgDevice && isAdvisorLoggedInAsClient ? 'top-[94px]' : 'top-[30px]',
        )}
      >
        <div className="w-[132px] h-auto text-secondary">
          <XSavvyLogo fill="currentColor" />
        </div>
      </div>
      <div
        style={{
          minHeight: '100vh',
          position: 'relative',
          paddingTop: lgDevice && isAdvisorLoggedInAsClient ? '64px' : '0', // Add padding for banner
        }}
        className="flex flex-col items-center justify-center"
      >
        <div className="my-12" style={{ maxWidth, maxHeight }}>
          {children}
        </div>
        <div className="w-full absolute left-0 pt-0 bottom-0 pb-8">
          <XSavvyFooter />
        </div>
      </div>
    </div>
  );
}
